import React from 'react';

const MinimalLayout = (props) => {
  return <div className="minimal-layout">{props.children}</div>;
};

export default MinimalLayout;
